<!--
 * @Description: 举报消息卡片
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2024-08-26 16:10:22
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-12-04 11:22:45
-->

<script setup lang="ts">
import { openWindowWithWorkspace } from '@/utils/tool'
import FileThumbnail from '@/components/knowledge/file-thumbnail/index.vue'

const props = defineProps({
  messageData: {
    type: Object,
    default: () => { },
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
})

const limitVisible = ref(false)

// 立即查看 - 进入平台知识库，选中最新栏目
function toDetail(val: any) {
  openWindowWithWorkspace('/platform-knowledge-search')
}

// 联系客服
function toService() {
  limitVisible.value = true
}

interface FileInfo {
  id: number
  name: string
  suffix: string
  type: number // type:0文件,type:1投融资,type:2专利
}
const fileInfo: ComputedRef<FileInfo> = computed(() => (props.messageData.feedConfigId === 65 && props.messageData.content) ? JSON.parse(props.messageData.content) as FileInfo : {} as FileInfo)
</script>

<template>
  <div class="report-card-wrap" :class="{ 'is-small': isSmall }">
    <div class="time">
      {{ messageData.createTime }}
    </div>
    <div class="content">
      <div v-if="messageData.feedConfigId === 65">
        <div class="title">
          {{ messageData.operateName }}
        </div>
        <div class="flex items-center">
          <div class="file-wrap flex items-center">
            <FileThumbnail v-if="fileInfo.suffix" :url="`file.${fileInfo.suffix}`" :size="20" />
            <div class="file-name ellipsis">
              {{ fileInfo.name }}
            </div>
          </div>
          <div class="more" />
        </div>
      </div>
      <div v-if="[63, 64].includes(messageData.feedConfigId)">
        <div class="title">
          {{ messageData.operateName }}
        </div>
        <div class="report-tip">
          {{ messageData.content }}
        </div>
      </div>
    </div>
    <!-- 根据状态判断 -->
    <div class="opera-wrap">
      <button v-if="messageData.feedConfigId === 65" class="opera-btn button-gradient"
        :data-ph-capture-attribute-page-actions="$getPosthogPath(['立即查看'])" @click="toDetail(messageData)">
        立即查看
      </button>
      <button v-if="messageData.feedConfigId === 64" class="opera-btn button-gradient"
        :data-ph-capture-attribute-page-actions="$getPosthogPath(['联系客服'])" @click="toService()">
        联系客服
      </button>
    </div>
    <!-- 达到上限弹窗 -->
    <LimitDialog v-model="limitVisible" class="contact-service-dialog">
      <template #default>
        <div class="tip text-[14px] text-[#242F57]">
          扫描二维码，联系客服
        </div>
      </template>
    </LimitDialog>
  </div>
</template>

<style lang="scss" scoped>
.report-card-wrap {
  position: relative;
  width: 100%;
  padding: 20px 24px;
  background: #FFFFFF;
  border-radius: 8px;

  &.is-small {
    padding: 12px;

    .time {
      margin-bottom: 0px;
    }

    .content {
      font-size: 12px;
      line-height: 18px;

      .title {
        margin-bottom: 6px;
      }

      .file-wrap {
        padding: 6px;
      }
    }

    .opera-wrap {
      .opera-btn {
        margin-top: 8px;
        padding: 3px 12px;
        font-size: 12px;
      }
    }

  }

  .time {
    margin-bottom: 8px;
    font-size: 12px;
    color: #8FA1B2;
    line-height: 18px;
  }

  .content {
    .title {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: 14px;
      color: #242F57;
      line-height: 24px;
    }

    .file-wrap {
      margin-right: 10px;
      padding: 7px 8px;
      background: #F7F8FA;
      font-size: 14px;
      color: #242F57;
      line-height: 20px;

      .file-name {
        max-width: 870px;
        margin-left: 8px;
      }
    }

    .report-tip {
      font-size: 14px;
      color: #242F57;
      line-height: 21px;
    }

    .more {
      width: 20px;
      height: 20px;
      background: url('../../icons/more.png') no-repeat;
      background-size: contain;
    }
  }

  .opera-wrap {
    .opera-btn {
      margin-top: 8px;
      padding: 6px 12px;
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss">
.limit-dialog {
  &.contact-service-dialog {
    height: 260px !important;

    .dialog-body {
      padding-top: 0;

      .tip-wrap {
        margin-bottom: 24px;
      }

      .img {
        width: 140px;
        height: 140px;
      }
    }
  }
}
</style>
